const bannerImages = [
  {
    link: 'baby',
    image: 'https://d1006gs7mu1yt6.cloudfront.net/task/3/22/1765822403558-WEBBANNER4.jpg',
  },
  {
    link: 'gadgets',
    image: 'https://d1006gs7mu1yt6.cloudfront.net/task/3/22/1765822403558-WEBBANNER3.jpg',
  },
  {
    link: 'beauty',
    image: 'https://d1006gs7mu1yt6.cloudfront.net/task/3/22/1765822403558-WEBBANNER1.jpg',
  },
]

const domain = 'luxuracart.com'
const domainName = 'luxuracart'
const domainLogo = '/luxura-cart-logo-white-gold-cropped.png'
const bgColor = '#000'
const favicon = '/favicon.ico'
const email = 'support@luxuracart.com'
const emailGlobal = ''
const metaTitle = 'Shop Premium USA Brands Online at Luxura Cart &ndash; Luxura Cart'
const metaDescription = 'Buy online Premium USA Brands from Luxura Cart with free shipping. Explore USA genuine products and receive with easy ordering and smooth shopping at your doorstep.'
const headerBg = '#000'
const subMenu = '#000'
const bannesImages = bannerImages
const buttonColor = '#f7f7f7'
const address = 'Luxura Ventures LLC <br />Sharjah Media City<br /> Sharjah, UAE'
const phone = ''
const addressGlobal = ''
const phoneGlobal = ''

const Host = {
  domain: domain,
  domainName: domainName,
  domainLogo: domainLogo,
  bgColor: bgColor,
  favicon: favicon,
  email: email,
  metaTitle: metaTitle,
  metaDescription: metaDescription,
  headerBg: headerBg,
  subMenu: subMenu,
  bannesImages: bannesImages,
  buttonColor: buttonColor,
  address: address,
  phone: phone,
  emailGlobal: emailGlobal,
  addressGlobal: addressGlobal,
  phoneGlobal: phoneGlobal
}


export default Host;